<template>
  <div class="replayInput">
    <el-input
      v-model="comment"
      :placeholder="placeholder"
      clearable
      :disabled="disabled"
    ></el-input>
    <p class="publish" @click="publishComment" v-if="!disabled">发布</p>
    <p class="publish noPublish" v-else>发布</p>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "写下你的评论…",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comment: "",
    };
  },
  methods: {
    //发布
    publishComment() {
      this.$emit("publishComment", this.comment);
    },
  },
};
</script>
<style lang="scss" scoped>
.replayInput {
  display: flex;
  align-items: center;
  padding: 19px 0;
  .publish {
    width: 68px;
    height: 36px;
    opacity: 1;
    background: #fc5623;
    border-radius: 4px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    margin-left: 8px;
    cursor: pointer;
  }
  .noPublish {
    background: #e9e9eb;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #f7f7f7;
  }
}
</style>
